import React, { useEffect, useState } from 'react';
import Paginated from './Paginated';
import { COLUMN } from './COLUMN';
import { ClientDetailData, clientDetails } from '../../actions/auth';
import { getDate } from '../../utils/helper';
import { Link } from 'react-router-dom';
import swal from 'sweetalert';
import AdminHeader from '../layout/AdminHeader';
import { encrypt } from '../../utils/encodingdecoding';

function ClientList() {
	const [loader, setLoader] = useState(false);
	const [formData, setFormData] = useState([]);
	const [response, setResponse] = useState();

	const updateData = async () => {
		setLoader(true);
		const token = JSON.parse(localStorage.getItem('token_gen1'));
		clientDetails(token?.access_token).then((res) => {
			setResponse(res);
			setLoader(false);
		});
	};

	useEffect(() => {
		 sessionStorage.removeItem("usermerchcode")
        sessionStorage.removeItem("venClientCode")
		updateData();
	}, []);

	useEffect(() => {
		if (response) {
			const tempData = response?.map((val) => ({
				...val,
				// code: (
				//     <Link to="/admin/wallet-report" state={val.merchcode} className="edit_btn">
				//         {val.merchcode}
				//     </Link>
				// ),
				// islive:val.isLive,
				name: (
					<Link
						to='/admin/wallet-report'
						state={val}
						onClick={() => {
							sessionStorage.setItem(
								'usermerchcode',
								encrypt(val.merchcode),
							);
						}}
						className='edit_btn'>
						{val.name}
					</Link>
				),
				email: val.email,
				companyName: val.companyname,
				mobile: val.contactnumber,
				emailConfirmed: val.emailconfirmed,
				startDate: getDate(val.Created, 'DD-MM-YYYY'),
				status: (
					<div className='form-check form-switch'>
						<input
							className='form-check-input'
							type='checkbox'
							role='switch'
							checked={val.cardStatus === 'True'}
							onChange={(e) => handleStatusChange(e, val)}
						/>
					</div>
				),
			}));
			if (tempData) {
				tempData.sort(function (a, b) {
					if (a.Created === null) {
						return 1;
					} else if (b.Created === null) {
						return -1;
					}
					const dateA = new Date(a.Created);
					const dateB = new Date(b.Created);
					if (dateA < dateB) {
						return 1;
					} else if (dateA > dateB) {
						return -1;
					} else {
						const timeA = dateA.getTime();
						const timeB = dateB.getTime();
						return timeB - timeA;
					}
				});
			}
			setFormData(tempData);
		}
	}, [response]);

	const merchantId = localStorage.getItem('merchantId');
	useEffect(() => {
		localStorage.removeItem('merchantId');
	}, [merchantId]);

	const handleStatusChange = async (e, val) => {
		setLoader(true);
		const updatedStatus = e.target.checked;
		const token = JSON.parse(localStorage.getItem('token_gen1'));
		const body = {
			name: val.isLive,
			code: val.code,
			status: updatedStatus,
		};
		ClientDetailData(token?.access_token, val.merchcode, body).then(
			(res) => {
				if (res.message === 'Record Updated Successfully.') {
					updateData();
					setResponse(false);
					swal({
						position: 'center',
						icon: 'success',
						title: 'Client updated successfully',
						showConfirmButton: false,
						timer: 3000,
					});
					// setLoader(false);
				} else {
					swal({
						title: ' Oops!',
						text: res.message,
						icon: 'error',
						button: 'oh no!',
						timer: 3000,
					});
					setLoader(false);
				}
			},
		);
	};

	return (
		<>
			<AdminHeader name={'Reseller Gift Card User'} />
			{loader && (
				<div className='mainPreloaderMain'>
					<div className='mainPreloader'>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
					</div>
				</div>
			)}
			<div
				className='dashboard__mainPage'
				style={{ width: '100%', marginLeft: '0px' }}>
				<div className='dashboard__content'>
					<div className='container-fluid'>
						<div className='row'>
							<div className='dashboard__customersCard'>
								<div className='dashboard__header'>
									<div className='dashboard__left'>
										<h4 id='voucher_details'>User List</h4>
									</div>
								</div>
								<div className='dashboard__body'>
									<Paginated
										data={formData ? formData : []}
										columns={COLUMN}
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}

export default ClientList;
